<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf='!modal'>
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-title>Import Contacts</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ng-container *ngIf="!platform.is('capacitor')">
    <img src="../../../assets/images/select-a-client.png" style='width:300px;'/>
    <h4>We can easily import your existing client information if you have a digital client list.</h4>
    We can import your data from a 'CSV' or spreadsheet file which can be exported from most apps.
    <br /><br />
    <ion-button target='_top' fill="solid" color='primary' href="mailto:stephen@salonmonster.com?subject=Please import my clients into salonMonster&body=Welcome! We're ready to import your client data for you. Please attach your client list in CSV or spreadsheet format to this email and click send :)">Email us your client list</ion-button>
    <br />    <br /><br />
    <h4>We can also import existing appointments from:</h4>
    <ul>
      <li>Fresha</li>
      <li>Styleseat</li>
      <li>Mind Body Online</li>
      <li>Rosy Salon</li>
      <li>Acuity Scheduling</li>
      <li>Timely</li>
      <li>Vagaro</li>
    </ul>
    <ion-button target='_top' fill="outline" color='primary' href="https://support.salonmonster.com/en/collections/3269068-switching-to-salonmonster">Learn about how to send us your data</ion-button> 
    <br /><br />
    If you are currently using a system not listed above get in touch and we'll see how we can help.
    <br /><br />
    <ion-button target='_top' fill="outline" color='primary' href="mailto:support@salonmonster.com?subject=I'd like to import my bookings into salonMonster&body=Hi, we're excited to help import your bookings for you. Please let us know which system you currently use and we'll send you the instructions on how to proceed :)">Contact us about importing your bookings</ion-button>
  </ng-container>

  <ion-list *ngIf="platform.is('capacitor')">
    <ion-item *ngFor="let contact of contactList">
      <!-- <ion-note> -->
        {{ contact.name.givenName }} {{ contact.name.familyName }}
      <!-- </ion-note> -->

      <ion-button item-right  clear (click)="onClientImport(contact)">
        <ion-icon name='add'></ion-icon>
        Import
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
